// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c88cb469","977":"a7463705"}[chunkId] + ".chunk.js";
};